// Sample actions
export const ADD_MENU_DATA = "ADD_MENU_DATA";
export const ADD_ITEM_CART = "ADD_ITEM_CART";
export const DEl_ITEM_CART = "DEl_ITEM_CART";
export const REMOVE_ITEM_CART = "REMOVE_ITEM_CART";
export const ADD_ALL_DINING_RESTAURANTS = "ADD_ALL_DINING_RESTAURANTS"
export const ADD_ALL_DELIVERY_RESTAURANTS = "ADD_ALL_DELIVERY_RESTAURANTS"
export const SELECT_RESTAUARANT = "SELECT_RESTAUARANT"
export const ADD_USER_DATA = "ADD_USER_DATA"
export const ADD_MENU_ITEM = "ADD_MENU_ITEM"
export const ADD_ALL_RESTAURANTS = "ADD_ALL_RESTAURANTS"

export const LOGOUT = "LOGOUT"
export const GET_ORDER_DETAILS  = "GET_ORDER_DETAILS"
export const GET_REVIEWS = "GET_REVIEWS"
export const DEL_RESTO_CART = "DEL_RESTO_CART"
